import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const slaPolicySchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  name: z.string(),
  description: z.string().nullable().optional(),
  rank: z.number().int(),
  conditions: jsonMetaSchema.default({}),
  first_reply_minutes: z.number().int().positive(),
  next_reply_minutes: z.number().int().positive().nullable().optional(),
  resolution_minutes: z.number().int().positive().nullable().optional(),
  business_hours_only: z.boolean(),
  is_active: z.boolean(),
  is_default: z.boolean(),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type SlaPolicy = z.infer<typeof slaPolicySchema>;

export const createSlaPolicySchema = z.object({
  name: z.string().min(1).max(200),
  description: z.string().optional(),
  rank: z.number().int().default(0),
  conditions: jsonMetaSchema.optional(),
  first_reply_minutes: z.number().int().positive(),
  next_reply_minutes: z.number().int().positive().optional(),
  resolution_minutes: z.number().int().positive().optional(),
  business_hours_only: z.boolean().default(false),
  is_active: z.boolean().default(true),
  is_default: z.boolean().default(false),
});

export const updateSlaPolicySchema = createSlaPolicySchema.partial();
